const RecallSource = Object.freeze({
  LAST_SEARCH: 'last_search',
  PINNED: 'pinned',
} as const);

export type RecallSource = (typeof RecallSource)[keyof typeof RecallSource];

export const allRecallSources: [RecallSource, ...RecallSource[]] = Object.values(RecallSource) as [
  RecallSource,
  ...RecallSource[],
];

export default RecallSource;
